import { render, staticRenderFns } from "./OnlineCourses.vue?vue&type=template&id=3a268671&scoped=true"
import script from "./OnlineCourses.vue?vue&type=script&lang=js"
export * from "./OnlineCourses.vue?vue&type=script&lang=js"
import style0 from "./OnlineCourses.vue?vue&type=style&index=0&id=3a268671&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a268671",
  null
  
)

export default component.exports